export const List = () => import('./List.vue');
export const Print = () => import('./Print.vue');
export const OutLeaving = () => import('./OutLeaving.vue');
